function Footer() {
  return (
    <footer className="bg-gray-800 text-white text-center py-5 mt-10">
      <div className="max-w-7xl mx-auto px-4 space-y-2 text-sm">

        {/* Copyright */}
        <p>
          © {new Date().getFullYear()} Shine Agri Allied & Marketing
          Multistate Cooperative Society Ltd. All rights reserved.
        </p>

        {/* Legal Links */}
        <p className="flex justify-center gap-6 flex-wrap text-gray-300">
          <a
            href="/policies#terms"
            className="hover:text-emerald-400 underline"
          >
            Terms & Conditions
          </a>

          <a
            href="/policies#privacy"
            className="hover:text-emerald-400 underline"
          >
            Privacy Policy
          </a>

          <a
            href="/policies#refunds"
            className="hover:text-emerald-400 underline"
          >
            Cancellation & Refunds
          </a>

          <a
            href="/policies#contact"
            className="hover:text-emerald-400 underline"
          >
            Contact Us
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
